<style>
.v-navigation-drawer--mini-variant .logout {
  display: none;
}

.cashier {
  height: 100%;
  position: fixed;
  width: 0%;
  z-index: 500;
  right: 0;
  transition: width 0.1s;
}

.cashier.cashier-active {
  height: 100%;
  position: fixed;
  width: 90%;
  z-index: 500;
  right: 0;
  padding: 16px;
}
</style>

<template>
  <v-app id="inspire">
    <v-dialog retain-focus :value="showbarcode" fullscreen v-on:keydown.esc="closePrintBarcode">
      <v-btn
        style="z-index:20; position:absolute; top:0; right:0;"
        @click="
          () => {
            this.$store.commit('SET_BARCODE_PRINT', false);
            this.$store.commit('SET_BARCODES', []);
          }
        "
        color="error"
        dark
        icon
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-card>
        <div id="barcodes" style="z-index:999;">
          <div v-for="barcode in barcodes" :key="barcode" style="page-break-after: always;">
            <barcode
              :value="barcode"
              format="CODE128"
              width="1"
              height="20"
              margin="0"
              display-value="true"
              text-margin="0"
              font-size="10"
              style="margin-top:6px; width: 3.6in;
    height: .5in;
    box-sizing: border-box; padding: 12px 18px"
            >
              Show this if the rendering fails.
            </barcode>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <div v-if="job_order_shown()" class="print-me" style="visibility: hidden; display:none;">
      <v-list>
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title>Design Code</v-list-item-title>
            <v-list-item-subtitle>{{ design_code }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title>Item Category</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.category }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title>Customer Name</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.customer.name }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title>Karat of Gold</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.karat }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        two-line
        v-if="jobOrder.category == 'Wedding rings' || jobOrder.category == 'Wedding Rings'"
      >
        <v-list-item-content>
          <v-list-item-title>Engraving</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.engraving }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        two-line
        v-if="jobOrder.category == 'Wedding rings' || jobOrder.category == 'Wedding Rings'"
      >
        <v-list-item-content>
          <v-list-item-title>Groom</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.couple_name1 }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title>{{ is_wedding_ring() ? 'Groom ' : '' }}Size/s</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.size }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        two-line
        v-if="jobOrder.category == 'Wedding rings' || jobOrder.category == 'Wedding Rings'"
      >
        <v-list-item-content>
          <v-list-item-title>{{ is_wedding_ring() ? 'Groom ' : '' }}Width</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.width }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        two-line
        v-if="jobOrder.category == 'Wedding rings' || jobOrder.category == 'Wedding Rings'"
      >
        <v-list-item-content>
          <v-list-item-title>{{ is_wedding_ring() ? 'Groom ' : '' }}Thickness</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.thickness }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        two-line
        v-if="jobOrder.category == 'Wedding rings' || jobOrder.category == 'Wedding Rings'"
      >
        <v-list-item-content>
          <v-list-item-title
            >{{ is_wedding_ring() ? 'Groom ' : '' }}Weight of Gold</v-list-item-title
          >
          <v-list-item-subtitle>{{ jobOrder.weight }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title
            >{{ is_wedding_ring() ? 'Groom ' : '' }}Color of Gold</v-list-item-title
          >
          <v-list-item-subtitle>{{ jobOrder.color }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title
            >{{ is_wedding_ring() ? 'Groom ' : '' }}No. and Size of Diamond</v-list-item-title
          >
          <v-list-item-subtitle>{{ jobOrder.no_of_diamond }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        two-line
        v-if="jobOrder.category == 'Wedding rings' || jobOrder.category == 'Wedding Rings'"
      >
        <v-list-item-content>
          <v-list-item-title>Bride</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.couple_name2 }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        two-line
        v-if="jobOrder.category == 'Wedding rings' || jobOrder.category == 'Wedding Rings'"
      >
        <v-list-item-content>
          <v-list-item-title>Bride Size</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.couple2_size }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        two-line
        v-if="jobOrder.category == 'Wedding rings' || jobOrder.category == 'Wedding Rings'"
      >
        <v-list-item-content>
          <v-list-item-title>Bride Width</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.couple2_width }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        two-line
        v-if="jobOrder.category == 'Wedding rings' || jobOrder.category == 'Wedding Rings'"
      >
        <v-list-item-content>
          <v-list-item-title>Bride Thickness</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.couple2_thickness }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        two-line
        v-if="jobOrder.category == 'Wedding rings' || jobOrder.category == 'Wedding Rings'"
      >
        <v-list-item-content>
          <v-list-item-title>Bride Weight of Gold</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.couple2_weight }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        two-line
        v-if="jobOrder.category == 'Wedding rings' || jobOrder.category == 'Wedding Rings'"
      >
        <v-list-item-content>
          <v-list-item-title>Bride Color of Gold</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.couple2_color }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        two-line
        v-if="jobOrder.category == 'Wedding rings' || jobOrder.category == 'Wedding Rings'"
      >
        <v-list-item-content>
          <v-list-item-title>Bride No. and Size of Diamond</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.couple2_no_of_diamond }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        two-line
        v-if="
          jobOrder.category == 'Pendants, earrings, and other accessories' ||
            jobOrder.category == 'Pendants, Earrings, and Other Accessories'
        "
      >
        <v-list-item-content>
          <v-list-item-title>Product Type</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.product_type.name }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        two-line
        v-if="
          jobOrder.category == 'Engagement rings' ||
            jobOrder.category == 'Engagement Rings' ||
            jobOrder.category == 'Pendants, earrings, and other accessories' ||
            jobOrder.category == 'Pendants, Earrings, and Other Accessories'
        "
      >
        <v-list-item-content>
          <v-list-item-title>GIA</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.gia }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <!--<v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title>Price</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.price.toLocaleString() }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title>Cost of Goods Sold</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.cogs }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      -->

      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title>Quantity</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.quantity }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title>Attachments</v-list-item-title>
          <div width="500" v-for="image in jobOrder.files" :key="image.id">
            <img :src="'/attachement/' + image.path" style="max-height: 200px; max-width=200px;" />
          </div>
        </v-list-item-content>
      </v-list-item>

      <!--<v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title>Amount Downpayment</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.deposit.toLocaleString() }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title>Amount Receivable/Balance</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.balance.toLocaleString() }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>-->

      <v-list-item
        two-line
        v-if="jobOrder.category == 'Wedding rings' || jobOrder.category == 'Wedding Rings'"
      >
        <v-list-item-content>
          <v-list-item-title>Wedding Date</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.wedding_date }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        two-line
        v-if="jobOrder.category == 'Wedding rings' || jobOrder.category == 'Wedding Rings'"
      >
        <v-list-item-content>
          <v-list-item-title>Date Delivered from Factory</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.date_delivered_from_factory }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title>Date of Order</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.date_ordered }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title>Date Picked Up/Purchased by Customer</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.date_pickup }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title>Pick up Date</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.delivery_date }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title>Rush Order</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.rush }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title>Notes</v-list-item-title>
          <v-list-item-subtitle>{{ jobOrder.notes }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </div>
    <div class="d-print-none" id="wagmokoprint">
      <v-sheet
        tile
        :class="`elevation-5 cashier ${createSale ? 'cashier-active' : ''}`"
        style="overflow: auto;"
        v-on:keydown.esc="
          {
            console.log('escape');
          }
        "
      >
        <v-overlay z-index="1000" :value="cashierLoading">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-overlay>
        <v-container fluid>
          <v-row align="start">
            <v-col :cols="12">
              <v-text-field
                ref="barcodeinput"
                v-model="barcode"
                label="Barcode"
                outlined
                @keyup.enter="barcodeEntered"
                @blur="focusBarcodeInput"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="start">
            <v-col :cols="8">
              <v-btn
                v-if="sales.length > 0"
                @click="
                  () => {
                    sales = [];
                  }
                "
                outlined
                color="blue"
              >
                Clear Items
              </v-btn>
              <v-row align="start">
                <v-col :cols="6" v-for="(inventory, index) in sales" :key="index">
                  <v-card class="mx-auto">
                    <v-btn
                      style="z-index:20; position:absolute; top:0; right:0;"
                      class="mt-1 mr-1"
                      @click="removeItemCashier(inventory, index)"
                      color="error"
                      dark
                      icon
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-card-text>
                      <div v-if="inventory.set_id != null">{{ inventory.set.name }}</div>
                      <div>{{ inventory.product.product_type.name }}</div>
                      <p class="display-2 text--primary">
                        {{ inventory.product.name }}
                      </p>
                      <p>{{ inventory.serial }}</p>
                      <div class="text--primary">
                        PHP {{ inventory.product.price.toLocaleString() }}
                      </div>
                      <div class="text--primary">
                        <v-text-field
                          :disabled="inventory.set_id != null"
                          v-model="inventory.discount"
                          @focus="discountFocused"
                          @blur="discountBlurred"
                          label="discount"
                          hide-details
                          dense
                          outlined
                        ></v-text-field>
                      </div>
                      <div class="text--primary">
                        PHP {{ (inventory.product.price - inventory.discount).toLocaleString() }}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="4">
              <v-row align="start">
                <v-col :cols="12">
                  <v-card>
                    <v-card-title class="subheading font-weight-bold"
                      >Transaction details</v-card-title
                    >
                    <v-divider></v-divider>
                    <v-list dense>
                      <v-list-item>
                        <v-list-item-content>Number of items:</v-list-item-content>
                        <v-list-item-content class="align-end" style="text-align: right">{{
                          sales.length
                        }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Total:</v-list-item-content>
                        <v-list-item-content class="align-end">{{
                          total.toLocaleString()
                        }}</v-list-item-content>
                      </v-list-item>
                      <v-text-field
                        ref="salediscount"
                        label="Discount"
                        outlined
                        style="padding: 0px 16px;"
                        v-model="saleDiscount"
                        dense
                        hide-details="auto"
                        :error-messages="inputErrorMessages('discount')"
                      ></v-text-field>
                      <v-list dense>
                        <v-list-item>
                          <v-list-item-content>Net Amount:</v-list-item-content>
                          <v-list-item-content class="align-end font-weight-black">{{
                            (total - saleDiscount).toLocaleString()
                          }}</v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-list>
                    <vsel
                      ref="barcodecustomerselect"
                      @search="filterCustomers"
                      label="name"
                      :options="customers"
                      v-model="cashierCustomer"
                      :style="{
                        padding: '0px 16px',
                        'margin-bottom': !!inputErrorMessages('customer_id') ? '0' : '16px'
                      }"
                    />
                    <v-list dense v-if="inputErrorMessages('customer_id')" style="padding: 0;">
                      <v-list-item>
                        <v-list-item-content style="padding:0 12px;" class="error--text v-messages">
                          {{ inputErrorMessages('customer_id').join(',') }}</v-list-item-content
                        >
                      </v-list-item>
                    </v-list>
                    <v-list-item v-if="createCustomer" style="padding: 0px 16px;">
                      <v-list-item-content>
                        <v-text-field
                          dense
                          ref="newcustomernameinput"
                          label="New customer"
                          v-model="newCustomerName"
                          v-on:keyup.enter="saveCustomer"
                          :error-messages="inputErrorMessages('name')"
                        ></v-text-field>
                      </v-list-item-content>
                      <v-list-item-icon>
                        <v-icon color="primary" @click="saveCustomer">mdi-plus</v-icon>
                      </v-list-item-icon>
                    </v-list-item>
                    <v-switch
                      style="padding: 0px 16px;"
                      v-model="createCustomer"
                      inset
                      flat
                      label="Add customer"
                    ></v-switch>
                    <v-text-field
                      ref="amountpaidinput"
                      label="Amount Paid"
                      dense
                      outlined
                      style="padding: 0px 16px;"
                      v-model="cashierAmountPaid"
                      :error-messages="inputErrorMessages('amount')"
                    ></v-text-field>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        @click="
                          () => {
                            closeCashier();
                            sales = [];
                          }
                        "
                        outlined
                        color="red"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        @click="saveSales"
                        :disabled="sales.length == 0"
                        color="indigo"
                        outlined
                      >
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
      <div
        @click="closeCashier()"
        v-if="createSale"
        style="height: 100%;
      position: fixed;
      width: 100%;
      z-index: 499;
      right: 0;
      transition: width 0.1s;
      background: none;"
      ></div>
      <v-navigation-drawer
        :expand-on-hover="expandOnHover"
        :mini-variant="miniVariant"
        v-model="drawer"
        color="teal"
        dark
        app
        mini-variant-width="56"
        ref="sideNavBar"
      >
        <v-list-item>
          <span style="display: inline-block; height: 68px;"> </span>
          <v-list-item-content>
            <v-list-item-title class="title"
              >&nbsp;<span>Ty Po Huat Goldsmith</span>
            </v-list-item-title>
            <v-list-item-subtitle>&nbsp;<span>Inventory and Sales</span> </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list>
          <v-list-item-group dense :value="activeMenu">
            <v-list-item
              v-for="(item, index) in menu"
              :key="index"
              class="px-4"
              link
              @click="goTo(item.link)"
            >
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
        <template v-slot:append>
          <div class="pa-2 logout">
            <v-btn
              block
              @click="
                () => {
                  $store.commit('logout');
                  $router.push('/login');
                }
              "
              >Logout</v-btn
            >
          </div>
        </template>
      </v-navigation-drawer>

      <v-app-bar app color="indigo" dark extended extension-height="4">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
        <v-toolbar-title>TY PO HUAT GOLDSMITH</v-toolbar-title>
        <v-spacer />
        <v-btn dark icon @click="goToCashier">
          <v-icon>mdi-printer-pos</v-icon>
        </v-btn>
        <v-menu min-width="150">
          <template v-slot:activator="{ on }">
            <v-btn dark icon v-on="on">
              <v-icon>mdi-account</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item
              @click="
                () => {
                  this.$store.commit('logout');
                  this.$router.push('/login');
                }
              "
            >
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>

      <v-content>
        <v-overlay z-index="1000" :value="this.$store.state.loading">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-overlay>
        <v-container fluid>
          <v-row align="start" justify="center">
            <v-col class="text-center">
              <router-view></router-view>
            </v-col>
          </v-row>
        </v-container>
      </v-content>
      <v-snackbar :timeout="2000" bottom left v-model="snackBar" :color="snackBarColor">
        {{ snackBarMessage }}
        <v-btn text @click="this.$store.commit('CLOSE_SNACKBAR')">
          Close
        </v-btn>
      </v-snackbar>
    </div>
    <confirm ref="mainconfirm" />
  </v-app>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import VueBarcode from 'vue-barcode';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import confirm from '../components/Confirm';

export default {
  components: {
    barcode: VueBarcode,
    vsel: vSelect,
    confirm: confirm
  },
  props: {
    source: String
  },
  data: () => ({
    createCustomer: true,
    newCustomerName: '',
    createCustomerErrorMessages: {},
    routeBeforeCashier: '/',
    dontFocus: false,
    errorMessages: {},
    cashierAmountPaid: '',
    cashierCustomer: '',
    cashierLoading: false,
    sales: [],
    saleDiscount: '',
    sets: [],
    barcode: '',
    createSale: false,
    drawer: null,
    expandOnHover: true,
    miniVariant: true,
    menu: [
      { title: 'Dashboard', link: '/', icon: 'mdi-monitor-dashboard' },
      { title: 'Supplier', link: '/supplier', icon: 'mdi-home-group' },
      { title: 'Product Type', link: '/producttype', icon: 'mdi-shape' },
      { title: 'Product', link: '/product', icon: 'mdi-ring' },
      { title: 'Set', link: '/set', icon: 'mdi-package-variant-closed' },
      { title: 'Job Order', link: '/joborder', icon: 'mdi-clipboard-list-outline' },
      { title: 'Sales', link: '/sale', icon: 'mdi-cash-multiple' },
      { title: 'Customer', link: '/customer', icon: 'mdi-account-supervisor' },
      { title: 'Raw Material', link: '/rawmaterial', icon: 'mdi-ruby' },
      { title: 'Report', link: '/report', icon: 'mdi-file-chart' },
      { title: 'User', link: '/user', icon: 'mdi-account' }
    ],
    snackBar: false,
    snackBarMessage: '',
    snackBarColor: ''
  }),
  computed: {
    ...mapState({
      customers: state => state.Customer.plaincustomers,
      showbarcode: state => state.showbarcode,
      barcodes: state => state.barcodes,
      jobOrder(state) {
        if (typeof state.JobOrder.jobOrder.data == 'undefined') {
          return {
            customer: {
              name: ''
            },
            product_type: {
              name: ''
            },
            job_order_materials: [],
            files: '',
            category: '',
            customer_id: undefined,
            couple_name1: '',
            couple_name2: '',
            contact_number: '',
            product_type_id: '',
            size: '',
            width: '',
            thickness: '',
            weight: '',
            karat: '',
            color: '',
            no_of_diamond: '',
            couple2_size: '',
            couple2_width: '',
            couple2_thickness: '',
            couple2_weight: '',
            couple2_color: '',
            couple2_no_of_diamond: '',
            engraving: '',
            design_code: '',
            gia: '',
            price: 0,
            cogs: '',
            files: undefined,
            deposit: 0,
            balance: 0,
            weddingDate: '',
            factoryDate: '',
            orderDate: '',
            deliveryDate: '',
            delivery: '',
            rush: '',
            notes: ''
          };
        }
        return state.JobOrder.jobOrder.data;
      }
    }),
    activeMenu() {
      return false;
    },
    total() {
      let total = 0;
      this.sales.forEach(inventory => {
        total += inventory.product.price - inventory.discount;
      });
      return total;
    },
    design_code: function() {
      if (typeof this.jobOrder.product != 'undefined' && this.jobOrder.product != null) {
        return this.jobOrder.product.inventories[0].serial;
      }
      return '';
    }
  },
  created: function() {
    this.checkLastAction();
    this.$store.watch(
      state => state.snackBarMessage,
      () => {
        const msg = this.$store.state.snackBarMessage;
        if (msg !== '') {
          this.snackBar = true;
          this.snackBarMessage = msg;
          this.snackBarColor = this.$store.state.snackBarColor;
          this.$store.commit('SET_SNACK_BAR', { message: '', color: 'success' });
        }
      }
    );
  },
  methods: {
    checkLastAction() {
      if (typeof this.$store.state.lastAction == 'undefined') {
        return;
      }

      let current_date = new Date().getTime() / 1000;
      this.$store.state.lastAction;
      if (current_date - this.$store.state.lastAction > 600) {
        //axios.delete(`/oauth/tokens/${this.$store.state.token}`);
        this.$store.commit('logout');
        this.$router.push('/login');
      } else {
        setTimeout(this.checkLastAction, 1000);
      }
    },
    ...mapActions(['Customer/fetchCustomers', 'Sale/fetchSales']),
    saveSales() {
      this.cashierLoading = true;
      let inventoryIds = [];
      let discounts = {};
      this.sales.forEach(item => {
        inventoryIds.push(item.id);
        discounts[item.id] = item.discount;
      });
      axios
        .post('api/v1/sale', {
          inventory_ids: inventoryIds,
          customer_id: this.cashierCustomer.id,
          amount: this.cashierAmountPaid,
          discount: this.saleDiscount,
          discounts: discounts
        })
        .then(response => {
          this.sales = [];
          this.cashierCustomer = '';
          this.$store.commit('SET_SNACK_BAR', {
            message: 'Sales saved..',
            color: 'success'
          });
          this['Sale/fetchSales']({ page: 0 });
        })
        .catch(response => {
          this.errorMessages = response.response.data.errors;
        })
        .finally(() => {
          this.cashierLoading = false;
        });
    },
    removeItemCashier(inventory, index) {
      if (inventory.set_id != null) {
        this.$refs.mainconfirm
          .open('Break set', 'Are you sure you want to break the set this product belongs to?')
          .then(confirm => {
            axios.post(`api/v1/set/${inventory.set_id}/dissolve`).then(response2 => {
              this.sales.splice(index, 1);
              this.sales.forEach((item, index) => {
                if (item.set_id == inventory.set_id) {
                  this.sales[index].set_id = null;
                  this.sales[index].discount = null;
                }
              });
            });
          });
      } else {
        this.sales.splice(index, 1);
      }
    },
    setEntered() {
      const serial = this.barcode;
      this.barcode = '';
      this.getSet(serial);
    },
    barcodeEntered() {
      const serial = this.barcode;
      let exist = false;
      if (serial.substring(0, 2).toLowerCase() == 's-') {
        this.setEntered();
        return;
      }
      this.sales.forEach(item => {
        if (item.serial == serial) {
          this.$store.commit('SET_SNACK_BAR', {
            message: 'Product already exist..',
            color: 'error'
          });
          exist = true;
        }
      });
      if (exist) {
        return;
      }
      this.barcode = '';
      axios
        .get(`api/v1/inventory/${serial}`)
        .then(response => {
          if (typeof response.data.data != 'undefined' && response.data.data.sale_id == null) {
            if (response.data.data.set_id != null) {
              this.$refs.mainconfirm
                .open(
                  'Break set',
                  'Are you sure you want to break the set this product belongs to?'
                )
                .then(confirm => {
                  axios.post(`api/v1/set/${response.data.data.set_id}/dissolve`).then(response2 => {
                    axios.get(`api/v1/inventory/${serial}`).then(response => {
                      this.sales.push(response.data.data);
                    });
                  });
                });
            } else {
              this.sales.push(response.data.data);
            }
          } else if (response.data.data.sale_id != null) {
            this.$store.commit('SET_SNACK_BAR', {
              message: 'Product already sold.',
              color: 'error'
            });
          } else {
            this.$store.commit('SET_SNACK_BAR', {
              message: 'Invalid product',
              color: 'error'
            });
          }
        })
        .catch(response => {
          if (response.response.data.message == 'Not Found.') {
            this.$store.commit('SET_SNACK_BAR', {
              message: 'Item not found.',
              color: 'error'
            });
          }
        });
    },
    getSet(serial) {
      axios
        .get(`api/v1/set/${serial}`)
        .then(response => {
          if (typeof response.data.data != 'undefined' && response.data.data.sale_id == null) {
            response.data.data.items.forEach(item => {
              axios.get(`api/v1/inventory/${item.serial}`).then(response => {
                this.sales.push(response.data.data);
              });
            });
          } else if (response.data.data.sale_id != null) {
            this.$store.commit('SET_SNACK_BAR', {
              message: 'Set already sold.',
              color: 'error'
            });
          } else {
            this.$store.commit('SET_SNACK_BAR', {
              message: 'Invalid product',
              color: 'error'
            });
          }
        })
        .catch(response => {
          if (response.response.data.message == 'Set Not Found.') {
            this.$store.commit('SET_SNACK_BAR', {
              message: 'Set not found.',
              color: 'error'
            });
          }
        });
    },
    inputErrorMessages(input) {
      return this.errorMessages[input];
    },
    goToCashier() {
      this['Customer/fetchCustomers']({ dontPaginate: false });
      this.createSale = true;
      this.routeBeforeCashier = this.$router.currentRoute.fullPath;
      if (this.$route.path !== '/') this.$router.push('/');
      this.focusBarcodeInput();
    },
    closeCashier() {
      this.createSale = false;
      if (this.$route.path !== this.routeBeforeCashier) this.$router.push(this.routeBeforeCashier);
    },
    goTo(route) {
      if (this.$route.path !== route) this.$router.push(route);
      // this.$router.push(route);
    },
    discountFocused() {
      this.dontFocus = true;
    },
    discountBlurred() {
      this.dontFocus = false;
      this.focusBarcodeInput();
    },
    focusBarcodeInput() {
      if (this.createSale) {
        // console.log(this.$refs.barcodecustomerselect.$refs.search);
        setTimeout(() => {
          if (
            this.$refs.amountpaidinput.$refs.input != document.activeElement &&
            this.$refs.barcodecustomerselect.$refs.search != document.activeElement &&
            this.$refs.salediscount.$refs.input != document.activeElement &&
            !this.dontFocus
          ) {
            if (
              this.createCustomer &&
              this.$refs.newcustomernameinput.$refs.input == document.activeElement
            ) {
              return;
            }
            this.$nextTick(this.$refs.barcodeinput.$refs.input.focus());
          }
        }, 500);
      }
    },
    closePrintBarcode() {
      console.log('print barcode close');
      this.$store.commit('SET_BARCODE_PRINT', false);
      this.$store.commit('SET_BARCODES', []);
    },
    async filterCustomers(search, loading) {
      loading(true);
      console.log(search);
      // let res = await axios.get('api/v1/customer', { params: { paginate: 0, filter: search } });
      await this['Customer/fetchCustomers']({ dontPaginate: false, filter: search });
      // console.log(res.data.data);
      // let res = await this['Customer/fetchCustomers']({ dontPaginate: false, filter: search });
      loading(false);
      // return res.data.data;
    },
    setCustomer(value) {
      console.log(value);
    },
    saveCustomer() {
      axios
        .post('api/v1/customer', { name: this.newCustomerName })
        .then(response => {
          this.errorMessages = [];
          this.cashierCustomer = response.data.customer;
          this.newCustomerName = '';
        })
        .catch(error => {
          if (error.response.status == 403) {
            this.$store.commit('SET_SNACK_BAR', {
              message: error.response.data['message'],
              color: 'error'
            });
          } else {
            this.errorMessages = error.response.data.errors;
          }
        })
        .finally(() => {
          this['Customer/fetchCustomers']({ dontPaginate: false });
        });
    },
    is_wedding_ring() {
      return this.jobOrder.category == 'Wedding rings' || this.jobOrder.category == 'Wedding Rings';
    },
    job_order_shown() {
      return !this.showbarcode && this.jobOrder.customer_id && this.$route.name == 'Job Order Show';
    }
  }
};
</script>
